export const renderHighlightedTextWithLinks = (text: string) => {
  // Regex to match @[****](XXXXX)
  // Making @ optional here as for a long time the sanitisation stripped the @, so comments from this period were broken.
  // Could also consider fixing these things in the database with a migration but seems overkill
  const regex = /@?\[(.*?)\]\(.*?\)/g;
  const parts = text.split(regex);
  const partsWithHighlights = parts.map((part, index) => {
    if (index % 2 === 1) {
      // This means it's the matched group which is ****
      return (
        <span key={`${index}-highlight`} className="text-teal-600">
          @{part}
        </span>
      );
    }
    return part; // Normal text not inside @[****]
  });

  // Go through partsWithHighlights find  which is a link and add it to an output
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Loop throigh partsWithHighlights, if the part is a string, split it on the link regex,
  // and add the parts to the output, but format the link part
  // If the part is not a string, just add it to the output
  const output = partsWithHighlights.map((part) => {
    if (typeof part === 'string' && part.match(urlRegex)) {
      return part.split(urlRegex).map((part, index) => {
        if (index % 2 === 1) {
          return (
            <a key={`${index}-link`} href={part} target="_blank" rel="noopener noreferrer" className="text-blue-500">
              {part}
            </a>
          );
        }
        return part;
      });
    }
    return part;
  });
  return output;
};
